<template>
  <div>
    <TemplateItemMobile :template="template" />
    <TemplateItemDesktop :template="template" />
  </div>
</template>

<script>
import TemplateItemMobile from './Mobile/PrivateTemplate';
import TemplateItemDesktop from './Desktop/PrivateTemplate';

export default {
  data() {
    return {}
  },
  props: ['template'],
  components: { TemplateItemMobile, TemplateItemDesktop }
}
</script>
